module.exports = __webpack_public_path__ + "assets/web_app_active_icn@1x.672d53ac.svg";